
import React from "react";
import { cn } from "@/lib/utils";
import { AspectRatio } from "@/components/ui/aspect-ratio";

interface FeatureBlockProps {
  title: string;
  description: string;
  imageUrl: string;
  imageAlt: string;
  reverse?: boolean;
  className?: string;
}

const VisualFeatureBlock = ({
  title,
  description,
  imageUrl,
  imageAlt,
  reverse = false,
  className,
}: FeatureBlockProps) => {
  return (
    <div className={cn(
      "grid md:grid-cols-2 gap-8 md:gap-16 items-center py-12 relative", 
      reverse && "md:flex-row-reverse", 
      className
    )}>
      <div className={cn("order-2 animate-fade-in", reverse ? "md:order-2" : "md:order-1")} style={{ animationDelay: "0.2s" }}>
        <h3 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-6">{title}</h3>
        <p className="text-lg md:text-xl text-gray-700 leading-relaxed">{description}</p>
      </div>
      
      <div className={cn(
        "order-1 flex justify-center animate-fade-in", 
        reverse ? "md:order-1" : "md:order-2"
      )} style={{ animationDelay: "0.4s" }}>
        <div className="relative w-full max-w-md">
          <AspectRatio ratio={1} className="overflow-hidden">
            {/* Enhanced background elements */}
            <div className="absolute inset-0 bg-gradient-to-br from-legatia-orange/30 to-legatia-yellow/30 rounded-3xl transform translate-x-3 translate-y-3"></div>
            <img 
              src={imageUrl} 
              alt={imageAlt} 
              className="rounded-2xl shadow-xl relative z-10 object-cover w-full h-full transform hover:scale-[1.02] transition-all duration-500"
            />
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-legatia-yellow/30 rounded-full z-0 animate-float"></div>
            <div className="absolute -top-4 -left-4 w-16 h-16 bg-legatia-orange/20 rounded-full z-0 animate-float" style={{ animationDelay: "1.5s" }}></div>
          </AspectRatio>
        </div>
      </div>
    </div>
  );
};

export default VisualFeatureBlock;
